<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../../api'
	import QueryCondition from '../../../components/statistics/QueryCondition5'
	import TableFuncs from '../../../components/statistics/TableFuncs'
	import { LINK_TYPES } from '../../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {
					appKey: '',
					advertType: '',
					startDate: null,
					endDate: null,
				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '日期',
						key: 'createDay',
						align: 'center',
						width: 150,
					},
					{
						title: '打开次数',
						key: 'openNum',
						align: 'center',
						width: 100,
					},
					{
						title: '用户展现率(%)',
						key: 'showRate',
						align: 'center',
						width: 150,
					},
					{
						title: '穿山甲',
						align: 'center',
						children: [{
							title: '请求数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.csj.reqNum)
							}
						}, {
							title: '请求成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.csj.reqOkNum)
							}
						},{
							title: '请求失败数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.csj.reqFailNum)
							}
						},{
							title: '请求成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.csj.reqOkRate)
							}
						},{
							title: '展示成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.csj.showNum)
							}
						},{
							title: '展示成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.csj.showRate)
							}
						},{
							title: '点击数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.csj.clickNum)
							}
						},{
							title: '点击率(%)',
							key: 'clickRate',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.csj.clickRate)
							}
						},]
					},{
						title: '优量汇',
						align: 'center',
						children: [{
							title: '请求数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.gdt.reqNum)
							}
						}, {
							title: '请求成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.gdt.reqOkNum)
							}
						},{
							title: '请求失败数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.gdt.reqFailNum)
							}
						},{
							title: '请求成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.gdt.reqOkRate)
							}
						},{
							title: '展示成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.gdt.showNum)
							}
						},{
							title: '展示成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.gdt.showRate)
							}
						},{
							title: '点击数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.gdt.clickNum)
							}
						},{
							title: '点击率(%)',
							key: 'clickRate',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.gdt.clickRate)
							}
						},]
					},{
						title: '百度',
						align: 'center',
						children: [{
							title: '请求数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.baidu.reqNum)
							}
						}, {
							title: '请求成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.baidu.reqOkNum)
							}
						},{
							title: '请求失败数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.baidu.reqFailNum)
							}
						},{
							title: '请求成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.baidu.reqOkRate)
							}
						},{
							title: '展示成功数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.baidu.showNum)
							}
						},{
							title: '展示成功率(%)',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.baidu.showRate)
							}
						},{
							title: '点击数',
							align: 'center',
							width: 120,
							render:(h,params)=>{
								return h('span', params.row.baidu.clickNum)
							}
						},{
							title: '点击率(%)',
							key: 'clickRate',
							align: 'center',
							width: 150,
							render:(h,params)=>{
								return h('span', params.row.baidu.clickRate)
							}
						},]
					}
				]
			}
		},
		created() {
			//this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				if (!params.appKey) {
					this.$Message.warning('请选择app')
					return
				}
				if (!params.advertType) {
					this.$Message.warning('请选择广告类型')
					return
				}
				this.queryParams = params
				this.refreshData()
			},
			exportExcel(params) {
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...params
				}
				api.statistics
					.getAdvertData(queryParams)
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.getAdvertData(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

		},



	}
</script>
